module.exports = __webpack_public_path__ + "static/media/link.7614ef80.svg";